export default __webpack_public_path__ + "static/media/carousel-right-btn-disabled-icon.bc193383.svg";